import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="border-t border-ink-700 bg-ink-950 py-12 sm:py-16" data-id="element-52" data-mp="au1uenirogiw">
      <div className="mx-auto w-full max-w-4xl" data-id="element-53" data-mp="ftwi6i78wpzq">
        <div className="px-4 sm:px-6" data-id="element-54" data-mp="fsleeidsvi8m">
          <div className="mx-auto mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-brand/15" data-id="element-55" data-mp="1un53rec6bzz">
            <GiftIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-56" data-mp="5vqhu5137rwz" />
          </div>
          <SectionHeading eyebrow="Zusätzlich erhältst du kostenlos" title="5 Exklusive Boni" data-id="element-57" data-mp="3o1lhcx8wzvm3" />
        </div>

        <div className="mt-8 grid gap-5 sm:gap-4 sm:px-6 md:grid-cols-2" data-id="element-58" data-mp="3t06f8q0p237d">
          {bonuses.map((bonus, index) => <article key={bonus.tag} className={`flex flex-col overflow-hidden border-y border-ink-700 bg-ink-800 sm:rounded-2xl sm:border ${index === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-59" data-mp="1mb9z79xbrynl" data-mpi={index}>
              <img src={bonus.image} alt={`${bonus.title} — Mockup des digitalen Bonus`} className="block w-full bg-ink-950 object-contain" width={1254} height={1254} loading="lazy" data-id="element-60" data-mp="3dflel92xv230" />

              <div className="flex flex-1 flex-col p-4 sm:p-5" data-id="element-61" data-mp="2zfkbro345kkw">
                <span className="w-fit rounded-md bg-brand/15 px-2 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-62" data-mp="2zfu5nmra4bvv">
                  {bonus.tag}
                </span>
                <h3 className="mt-3 font-display text-lg uppercase leading-tight text-white" data-id="element-63" data-mp="38htngha4bjzv">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-[15px] leading-snug text-white/65" data-id="element-64" data-mp="npriv4xf0jjk">{bonus.text}</p>
                <p className="mt-auto pt-4 text-sm font-semibold text-white/50" data-id="element-65" data-mp="iqyga7jo2cy6">
                  Wert:{' '}
                  <span className="text-white line-through decoration-bad/70" data-id="element-66" data-mp="3cj6g09ybpkn9">{bonus.value}</span>{' '}
                  <span className="text-brand" data-id="element-67" data-mp="3hhhs6rc3c78n">heute gratis</span>
                </p>
              </div>
            </article>)}
        </div>

        <div className="px-4 sm:px-6" data-id="element-68" data-mp="3lke2zvve2z21">
          <CtaBlock label="Ich will die 5 Boni gratis" showTimer={false} note="Die Boni sind nur im Einführungsangebot enthalten." className="mt-8" data-id="element-69" data-mp="3qiflofowkwcz" />
        </div>
      </div>
    </section>;
}